import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import ChooseCampaign from "./MultiCampaign/ChooseCampaign";
import TryAuth from "./TryAuth";
import {
  CampaignPage,
  NotFoundPage,
  CarouselExplorePage,
  OffersLandingPage,
  Sandbox,
  BeverageLanding,
  Beverage,
  BeverageThankYou,
  PassionsHub,
} from "../pages";
import { BeverageV3Landing } from "../pages/BeverageV3/BeverageV3Landing";
import { BeverageV3 } from "../pages/BeverageV3/BeverageV3";
import { BeverageV3ThankYou } from "../pages/BeverageV3/BeverageV3ThankYou";
import { Heading } from "./Heading";
import { TitleBarLayout } from "./Layout";
import "../styles/global/fonts.css";
import "../styles/global/theme.css";
import { ToastProvider } from "./Toast/ToastProvider";
import { ENV } from "../env";
import { PassionProfilePage } from "../pages/PassionProfilePage/PassionProfilePage";
import { ConsentPageChoose } from "../pages/ConsentPageChoose/ConsentPage";
import { ConsentThankYou } from "../pages/ConsentPageChoose/ConsentThankYou";
import { BeverageV2 } from "../pages/BeverageV2/Beverage";
import { BeverageV2Confirm } from "../pages/BeverageV2/BeverageConfirm";
import { BeverageV2Save } from "../pages/BeverageV2/BeverageSave";
import { BeverageOptConfirm } from "../pages/BeverageV2/BeverageOptConfirm";
import { BeverageV4 } from "../pages/BeverageV4/Beverage";
import {
  BeverageLandingV5,
  BeverageThankYouV5,
  BeverageV5,
} from "../pages/BeverageV5";
import { BeverageV6 } from "../pages/BeverageV6/Beverages";
import { BeverageV7 } from "../pages/BeverageV7/Beverages";
import { ExperienceTracker } from "./ExperienceTracker";

function App(props) {
  // use exc runtime event handlers
  // respond to configuration change events (e.g. user switches org)
  props.runtime.on("configuration", ({ imsOrg, imsToken, locale }) => {
    console.log("configuration change", { imsOrg, imsToken, locale });
  });
  // respond to history change events
  props.runtime.on("history", ({ type, path }) => {
    console.log("history change", { type, path });
  });

  return (
    <ErrorBoundary onError={onError} FallbackComponent={fallbackComponent}>
      <ToastProvider>
        <Router>
          <ExperienceTracker />
          <TitleBarLayout>
            <Routes>
              <Route path="/campaign" element={<CampaignPage />} />
              <Route path="/multiCampaign" element={<ChooseCampaign />} />
              <Route
                path="/share/explore"
                element={<CarouselExplorePage experienceType="bubbles" />}
              />
              <Route
                path="/share2/explore"
                element={
                  <CarouselExplorePage experienceType="bubbles2" showBanner />
                }
              />
              <Route
                path="/share3/explore"
                element={
                  <CarouselExplorePage experienceType="bubbles3" showBanner />
                }
              />
              <Route
                path="/video/explore"
                element={<CarouselExplorePage experienceType="video" />}
              />
              <Route
                path="/follow/explore"
                element={<CarouselExplorePage experienceType="follow" />}
              />
              <Route
                path="/travel/explore"
                element={<CarouselExplorePage experienceType="visual" />}
              />
              <Route
                path="/interactive/explore"
                element={<CarouselExplorePage experienceType="interactive" />}
              />
              <Route
                path="/derived-visual/explore"
                element={
                  <CarouselExplorePage experienceType="derived-visual" />
                }
              />
              <Route path="/offers" element={<OffersLandingPage />} />
              <Route path="/beverage" element={<BeverageLanding />} />
              <Route path="/beverage/preferences" element={<Beverage />} />
              <Route
                path="/beverage/thank-you"
                element={<BeverageThankYou />}
              />
              <Route
                path="/beverage/explore"
                element={<CarouselExplorePage experienceType="beverage" />}
              />
              <Route path="/beverage6" element={<BeverageV6 />} />
              <Route path="/beverage7" element={<BeverageV7 />} />
              <Route path="/beverage5" element={<BeverageLandingV5 />} />
              <Route path="/beverage5/preferences" element={<BeverageV5 />} />
              <Route
                path="/beverage5/thank-you"
                element={<BeverageThankYouV5 />}
              />
              <Route path="/beverage2" element={<BeverageV2 />} />
              <Route
                path="/beverage2/confirm"
                element={<BeverageV2Confirm />}
              />
              <Route
                path="/beverage2/opt-confirm"
                element={<BeverageOptConfirm />}
              />
              <Route
                path="/beverage2/thank-you"
                element={<BeverageV2 isThankYou={true} />}
              />
              <Route
                path="/beverage2/save"
                element={<BeverageV2Save />}
              ></Route>
              <Route path="/beverage3" element={<BeverageV3Landing />} />
              <Route path="/beverage3/preferences" element={<BeverageV3 />} />
              <Route
                path="/beverage3/thank-you"
                element={<BeverageV3ThankYou />}
              />
              <Route path="/beverage4" element={<BeverageV4 />}></Route>
              {ENV.FEATURE_FLAGS.sandboxEnabled && (
                <Route path="/sandbox/*" element={<Sandbox />} />
              )}
              <Route
                path="/passion-profile"
                element={<PassionProfilePage />}
              ></Route>
              <Route path="/passions-hub" element={<PassionsHub />}></Route>
              <Route path="/consent" element={<ConsentPageChoose />}></Route>
              <Route
                path="/consent/thank-you"
                element={<ConsentThankYou />}
              ></Route>
              <Route path="/404" element={<NotFoundPage autoRedirect />} />
              <Route path="*" element={<TryAuth />} />
            </Routes>
          </TitleBarLayout>
        </Router>
      </ToastProvider>
    </ErrorBoundary>
  );

  // Methods

  // error handler on UI rendering failure
  function onError() {}

  // component to show if UI fails rendering
  function fallbackComponent({ componentStack, error }) {
    return (
      <React.Fragment>
        <Heading
          type="h1"
          text="Something went wrong :("
          style={{ textAlign: "center", marginTop: "20px" }}
        />
        <pre>{componentStack + "\n" + error.message}</pre>
      </React.Fragment>
    );
  }
}

export default App;
